import React, { Component } from "react";
import ReactGA from 'react-ga';
import Link from "react-router-dom/Link";
import Page from "../Page";
import restartSVG from "img/restart.svg";
import tearPads from "img/tear-pads.png";
import bang from "img/bang.png";

import Popup from "../popup/Popup";

export default class Problem extends Component {
  constructor(props) {
    super(props);
    this.state = { showPopup: false };
  }

  showPopup = () => {
    this.setState({ showPopup: true });
  };

  render() {
    const { showPopup } = this.state;
    const {
      storeNumber,
      SKU_Count,
      annualSales,
      Avg_Weekly_Sales,
      resetData,
    } = this.props;

    ReactGA.pageview('/problem/1')

    return (
      <Page>
        <div className="problem-page">
          <div className="introduction-page__restart-block">
            <ul className="arrival-page__arms-list">
              <li>A</li>
              <li>R</li>
              <li>M</li>
              <li>S</li>
            </ul>
            <Link
              to={{ pathname: "/login", state: { prev: true } }}
              className="introduction-page__restart-btn"
              href="#"
              onClick={resetData}
            >
              <img
                className="introduction-page__restart-icon"
                src={restartSVG}
                alt=""
              />
              <span>Restart</span>
            </Link>
          </div>
          <div className="problem-page__main-section">
            <div className="problem-page__investigate-block">
              <div className="problem-page__animated-block">
                <img className="problem-page__bang-circle" src={bang} alt="" />
                <h1 className="problem-page__header-text">Missing Tear Pad!</h1>
                <p>
                  There is no tear pad displayed for this item! The customer
                  assumes the item is out of stock. However, your store currently
                  has <span className="red">three</span> Nest Cameras in stock.
                </p>
                <Link
                  to="/problem/1"
                  onClick={this.showPopup}
                  className="btn login-page__start-btn"
                >
                  <span>Let's investigate</span>
                </Link>
              </div>
            </div>
            <div className="problem-page__image-container">
              <img className="problem-page__image" src={tearPads} alt="" />
            </div>
          </div>

          {showPopup && (
            <Popup
              storeNumber={storeNumber}
              SKU_Count={SKU_Count}
              annualSales={annualSales}
              Avg_Weekly_Sales={Avg_Weekly_Sales}
            />
          )}
        </div>
      </Page>
    );
  }
}
